// @ts-ignore
import CryptoJS from 'crypto-js';
import {isEmpty} from 'lodash';
import {URL_FILTER_KEY} from '~/constants';

const SECRET_KEY = 'DKda35#@*LKDS43HY#JG';

export const setFilterParamUrl = (filter: Record<string, any>) => {
  const filterObj = {} as Record<string, any>;

  for (const prop in filter) {
    filterObj[prop] = filter[prop] ? JSON.stringify(filter[prop]) : '';
  }
  const newFilterParamsHashed = !isEmpty(filterObj) ? hashUrl(JSON.stringify(filterObj)) : undefined;

  return newFilterParamsHashed ? `${URL_FILTER_KEY}=${newFilterParamsHashed}` : '';
};

export const hashUrl = (value: string) => {
  return encodeURIComponent(CryptoJS.AES.encrypt(value, SECRET_KEY).toString());
};

export const decryptUrl = (hashedUrl: string) => {
  const bytes = CryptoJS.AES.decrypt(decodeURIComponent(hashedUrl), SECRET_KEY);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);

  return originalText;
};
